<ng-container *ngIf="invitations">
  <ng-container *ngFor="let invitat of invitations">
    <ng-container [ngSwitch]="invitat.status">
      <ng-container *ngSwitchCase="INVITATION_STATUS.pending">
        <ng-container [ngSwitch]="(userModel$ | async).id">
          <ng-container *ngSwitchCase="invitat.inviter?.id">
            <div class="invations">
              <div class="invations__icon">
                <app-icon-feather
                  icon="user-plus"
                  fill="inherit"
                  stroke="inherit"
                  width="18"
                  height="18"
                ></app-icon-feather>
              </div>
              <div class="invations__info">
                <p class="text--md">
                  {{
                    (
                      (invitat?.recepient?.firstName || "") +
                      " " +
                      (invitat?.recepient?.lastName || "")
                    ).trim() ||
                      invitat?.invitedName ||
                      invitat?.invitedEmail ||
                      "Invited person"
                  }}
                </p>
                <p class="text--sm c--dark-gray">An invitation has been sent</p>
                <p
                  class="button-wrapper gap-20 d-flex justify-content-start my-2"
                >
                  <button
                    pButton
                    pRipple
                    class="p-button-danger"
                    type="button"
                    label="CANCEL"
                    (click)="cancel(invitat.id)"
                  ></button>
                </p>
              </div>
              <div class="notification__date text--sm c--dark-gray">
                {{ invitat.createdAt | date : " h:mma M/d/yy" }}
              </div>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="invitat.recepient?.id">
            <div class="invations">
              <div class="invations__icon">
                <app-icon-feather
                  icon="user-plus"
                  fill="inherit"
                  stroke="inherit"
                  width="18"
                  height="18"
                ></app-icon-feather>
              </div>
              <div class="invations__info">
                <p class="text--md">
                  {{
                    (
                      (invitat?.inviter?.firstName || "") +
                      " " +
                      (invitat?.inviter?.lastName || "")
                    ).trim() || invitat?.inviter?.email
                  }}
                </p>
                <p class="text--sm c--dark-gray">
                  Wants you to act as a {{ invitat.recepient?.role | roleLabel }}
                </p>
                <p
                  class="button-wrapper gap-20 d-flex justify-content-start my-2"
                >
                  <button
                    pButton
                    type="submit"
                    label="ACCEPT"
                    (click)="accept(invitat.id)"
                  ></button>

                  <button
                    pButton
                    class="p-button-outlined"
                    type="button"
                    label="DECLINE"
                    (click)="decline(invitat.id)"
                  ></button>
                </p>
              </div>
              <div class="notification__date text--sm c--dark-gray">
                {{ invitat.createdAt | date : " h:mma M/d/yy" }}
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="INVITATION_STATUS.accepted"> </ng-container>
      <ng-container *ngSwitchCase="INVITATION_STATUS.declined"> </ng-container>
    </ng-container>
  </ng-container>
</ng-container>
